import { Injectable } from '@angular/core';
import { ContractRateService } from '@cai-services';
import { from, Observable } from 'rxjs';
import { BlobFile } from '../_models/blob-file.model';
import { ContractRate } from '../_models/contract-rate.model';

@Injectable({
  providedIn: 'root',
})
export class AppContractRateService {
  constructor(private readonly contractRateService: ContractRateService) {}

  /**
   * Retrieve all contract rates with specific parameters
   * @param page
   * @param size
   * @param sort
   * @param origin
   * @param airline
   * @param filterHistory
   * @param country
   * @param filterOptions
   * @returns
   */
  public getContractRates(
    page: number,
    size: number,
    sort: string,
    origin?: string,
    airline?: string,
    selectedOfficeId?: number,
    filterHistory?: boolean,
    type?: string,
    iatacass?: string,
    country?: string,
    filterOptions?: { [key: string]: string },
    search?: string,
  ): Observable<any> {
    if (sort == 'type,asc' || sort == 'type,desc') {
      sort = '';
    }
    return from(
      this.contractRateService.getContractRates(
        page,
        size,
        sort,
        filterOptions?.origin || origin,
        airline,
        selectedOfficeId,
        filterHistory,
        type,
        country,
        search,
        filterOptions?.commodity,
        filterOptions?.destination,
        filterOptions?.rateCategory,
        filterOptions?.aircraftTypes,
        filterOptions?.departureDate,
        iatacass,
      ),
    );
  }

  /**
   * Create a new contract rate
   * @param body
   * @returns
   */
  public createContractRate(body: ContractRate): Observable<any> {
    if (!body) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateForwarder.',
      );
    }

    return from(this.contractRateService.createContractRate(body));
  }

  /**
   * Update a contract rate
   * @param body
   * @returns
   */
  public updateContractRate(body: ContractRate): Observable<any> {
    if (!body.id) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateContract.',
      );
    }

    if (!body) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateContract.',
      );
    }

    return from(this.contractRateService.updateContractRate(body));
  }

  /**
   * Delete a contract rate
   * @param body
   * @returns
   */
  public deleteContractRate(rateId: number): Observable<any> {
    if (!rateId) {
      throw new Error(
        'Required rate id is null or undefined when calling deleteContractRate.',
      );
    }

    return from(this.contractRateService.deleteContractRate(rateId));
  }

  /**
   * Export to excel
   * @param airline
   * @param origin
   * @param iatacass
   * @param country
   * @returns
   */
  public exportExcel(
    airline: string,
    selectedOfficeId?: number,
    origin?: string,
    rateCategory?: string,
    iatacass?: string,
    country?: string,
    type?: string,
    departureDate?: string,
    rateId?: number,
  ): Observable<BlobFile> {
    return from(
      this.contractRateService.exportExcel(
        airline,
        selectedOfficeId,
        origin,
        country,
        rateCategory,
        iatacass,
        type,
        departureDate,
        rateId,
      ),
    );
  }
}
